import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid blog-page" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDetails',
  setup(__props) {

const blogShadow = defineAsyncComponent(() => import("@/components/theme/blog/details/blogShadow.vue"))
const blogList = defineAsyncComponent(() => import("@/components/theme/blog/details/blogList.vue"))
const blogGrid = defineAsyncComponent(() => import("@/components/theme/blog/details/blogGrid.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Blog",
      title: "Blog Details"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(blogShadow)),
        _createVNode(_unref(blogList)),
        _createVNode(_unref(blogGrid))
      ])
    ])
  ], 64))
}
}

})